import Label from "components/general/Label"

export function ColumnBibTeam({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "startSortOrder"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Bib',
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                const bib = row?.teamAthletes?.find(i => i?.athlete?.code === row?.participant?.code)?.bib
                return bib
            }
        }
    )
}
